/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { Station } from "./Station";
import * as t from "io-ts";

// required attributes
const StationsR = t.interface({
  page_info: PageInfo,

  stations: t.readonlyArray(Station, "array of Station")
});

// optional attributes
const StationsO = t.partial({});

export const Stations = t.intersection([StationsR, StationsO], "Stations");

export type Stations = t.TypeOf<typeof Stations>;
